import { Navigate, useLocation } from 'react-router-dom';
import { SessionStorage } from '../../services/storage';
import { useEffect, useState } from 'react';
import SessionExpiredModal from '../CommonComponent/Modal/SessionExpiredModal';

export interface IProtectRoute {
    children: JSX.Element
}
const ProtectedRoute = ({ children }: IProtectRoute) => {

    const [showModal, setShowModal] = useState(false);
    const location = useLocation();
    useEffect(() => {
        const handler = () => setShowModal(true);
        window.addEventListener('sessionExpired', handler);
        return () => window.removeEventListener('sessionExpired', handler);
    }, []);

    if (SessionStorage.get('employee') === null) {
        return <Navigate to='/' replace state={{ from: location }} />;
    }

    return (
        <>
            {children}
            {showModal && <SessionExpiredModal />}
        </>
    );
}

export default ProtectedRoute